import React, { useEffect, useState } from "react";
import { adminReferralPayouts, adminReferralMarkPaid } from "../lib/api";

const NAVY = "#0A1628";
const GOLD = "#D4AF37";
const GREEN = "#1A7A4A";
const RED = "#A32D2D";
const GREY = "#5a5d66";
const BG = "#F8F9FA";

const dollars = (c) => `$${((c || 0) / 100).toFixed(0)}`;
const formatDate = (s) => s ? new Date(s).toLocaleDateString() : "—";

const AdminReferralPayouts = () => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async () => { setData(await adminReferralPayouts()); };
  useEffect(() => { load(); }, []);

  const payOne = async (id) => {
    const method = window.prompt("Payment method (zelle / venmo / check):", "zelle");
    if (!method) return;
    const notes = window.prompt("Notes (optional):") || "";
    setBusy(true);
    try {
      await adminReferralMarkPaid(id, { method, notes });
      await load();
    } catch (e) {
      alert("Mark-paid failed: " + (e?.response?.data?.detail || "unknown"));
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-referral-payouts-page" style={{ minHeight: "100vh", background: BG, padding: "32px 22px 80px" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <p style={{ color: GOLD, letterSpacing: 4, fontSize: 13, fontFamily: "Bebas Neue, sans-serif", margin: 0 }}>
          ADMIN · REFERRAL PAYOUTS
        </p>
        <h1 className="font-display" style={{ fontSize: 56, color: NAVY, letterSpacing: 1, margin: "6px 0 4px" }}>
          $50 CASH OWED
        </h1>
        {data && (
          <p style={{ color: NAVY, fontSize: 17, margin: 0 }}>
            <strong>{data.count}</strong> payout{data.count === 1 ? "" : "s"} pending ·
            <strong style={{ color: RED, marginLeft: 6 }}>{dollars(data.total_owed_cents)} owed</strong>
          </p>
        )}

        <div style={{ marginTop: 24, background: "#fff", borderRadius: 12, padding: 0, overflow: "hidden", boxShadow: "0 12px 30px rgba(10,22,40,0.06)" }}>
          {!data ? (
            <div style={{ padding: 40, color: GREY, textAlign: "center" }}>Loading…</div>
          ) : data.items.length === 0 ? (
            <div style={{ padding: 40, textAlign: "center", color: GREY }}>
              No owed payouts. All clear.
            </div>
          ) : (
            <table data-testid="payouts-table" style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
              <thead>
                <tr style={{ background: BG }}>
                  <Th>REFERRER</Th><Th>REFERRED</Th><Th>PLAN</Th>
                  <Th>STRIPE CREDIT</Th><Th align="right">AMOUNT</Th>
                  <Th align="right">EARNED</Th><Th align="right">ACTION</Th>
                </tr>
              </thead>
              <tbody>
                {data.items.map((x) => (
                  <tr key={x.id} data-testid={`payout-row-${x.id}`} style={{ borderTop: `1px solid ${BG}` }}>
                    <td style={cell}>
                      <strong style={{ color: NAVY }}>{x.referrer_business || x.referrer_contractor_id.slice(0, 8)}</strong>
                    </td>
                    <td style={cell}>{x.referred_business || "—"}<br/>
                      <span style={{ fontSize: 11, color: GREY }}>{x.referred_email}</span>
                    </td>
                    <td style={cell}>{(x.referred_plan || "—").toUpperCase()}</td>
                    <td style={cell}>
                      {x.stripe_credit_applied
                        ? <span style={{ color: GREEN }}>✓ ${x.free_month_credit_cents / 100} credit applied</span>
                        : <span style={{ color: RED, fontSize: 12 }}>FAILED — {x.stripe_credit_error || "?"}</span>}
                    </td>
                    <td style={{ ...cell, textAlign: "right", color: GREEN, fontWeight: 700, fontSize: 16 }}>
                      {dollars(x.cash_payout_cents)}
                    </td>
                    <td style={{ ...cell, textAlign: "right" }}>{formatDate(x.created_at)}</td>
                    <td style={{ ...cell, textAlign: "right" }}>
                      <button data-testid={`pay-btn-${x.id}`} onClick={() => payOne(x.id)} disabled={busy} className="btn-gold tap"
                        style={{ minHeight: 36, fontSize: 12, padding: "0 14px" }}>
                        MARK PAID
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

const Th = ({ children, align }) => (
  <th style={{ textAlign: align || "left", padding: "12px 14px", fontSize: 11,
    color: GREY, letterSpacing: 1.5, fontFamily: "Bebas Neue, sans-serif" }}>{children}</th>
);
const cell = { padding: "14px", verticalAlign: "middle" };

export default AdminReferralPayouts;
